import React, {Component} from "react"

import authentication from "@irati/auth"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Success from "@irati/ui/src/Success"
import {H2, Body} from "@irati/ui/src/Typography"
import Loading from "@irati/ui/src/Loading"
import GenericModal from "@irati/ui/src/GenericModal"

import productSettingsService from "@irati/permissions/services/productSettings"
import DealList from "./DealList"
import TagList from "./TagList"
import {StyledDiv, StyledHR, StyledLabel} from "./styled/PerksVisibility"

const DEALS_TAB = "DEALS_TAB"
const TAGS_TAB = "TAGS_TAB"

interface Props extends InjectIntl {}

interface State {
  showModal: boolean
  showTab: string
  packageId: string | null
  load: Promise<void> | null
  allowLoading: boolean
}

class PerkVisibility extends Component<Props, State> {
  state: State = {
    showModal: false,
    showTab: TAGS_TAB,
    packageId: null,
    load: null,
    allowLoading: true
  }

  componentDidMount() {
    const business = authentication.business()
    const load = productSettingsService.get(business.uuid, business.rootTeamId).then((ps) => {
      this.setState({
        packageId: ps.perksSettings?.packageId || null
      })
    })
    this.setState({load})
  }

  onLabelClick = (tab: string) => {
    this.setState({
      showTab: tab,
      allowLoading: true
    })
  }

  handleSave = () => {
    this.setState({showModal: true})
    setTimeout(() => {
      this.setState({showModal: false})
    }, 5000)
  }

  hideSavedPopUp = () => {
    this.setState({showModal: false})
  }

  render() {
    const {showModal, packageId, showTab, load} = this.state
    const {formatMessage} = this.props

    return (
      <>
        <H2>
          <FormattedMessage id="admin.components.modal.headerTwo" />
        </H2>
        <Body marginBottom={5} marginTop={2}>
          <FormattedMessage id="admin.components.modal.headerFour" />
        </Body>
        <StyledDiv>
          <StyledLabel selected={showTab === TAGS_TAB} onClick={() => this.onLabelClick(TAGS_TAB)}>
            <FormattedMessage id="admin.components.modal.label.categories" />
          </StyledLabel>
          <StyledLabel selected={showTab === DEALS_TAB} onClick={() => this.onLabelClick(DEALS_TAB)}>
            <FormattedMessage id="admin.components.modal.label.perks" />
          </StyledLabel>
          <StyledHR />
          <div className="text-left">
            <Loading load={load}>
              {showTab === DEALS_TAB && <DealList tagId={packageId} ignoreBlacklist onSave={this.handleSave} />}
              {showTab === TAGS_TAB && <TagList onSave={this.handleSave} />}
            </Loading>
          </div>
        </StyledDiv>
        <GenericModal small hideActions show={showModal} onHide={this.hideSavedPopUp}>
          <Success message={formatMessage({id: "admin.components.perkVisibility.success.message"})} />
        </GenericModal>
      </>
    )
  }
}

export default injectIntl(PerkVisibility)
